import React, { ReactElement, FunctionComponent, isValidElement } from 'react';

type CtaBoxContentProps = {
    children: ReactElement | ReactElement[];
    qaRole?: string;
};

const CtaBoxContent: FunctionComponent<CtaBoxContentProps> = ({ children, qaRole }) => {
    // todo: check the children validation
    if (!isValidElement(children)) {
        return null;
    }

    return (
        <div className="cta-box__content" data-qa-role={qaRole || 'cta-box-content'}>
            {children}
        </div>
    );
};

export default CtaBoxContent;
